<template>
  <AppRadioGroup v-model="selectedProduct" :rules="[required]" :label="$tt(`select_visa_type_${country}`)">
    <AppRadio v-for="product in products" :value="product">
      <template #label>
        <component :is="product === selectedProduct ? 'strong' : 'span'">
          {{ tProductLabel(product.name, 'label') }}:&nbsp;
          {{ displayPrice(product.price) }}
        </component>
      </template>
    </AppRadio>
  </AppRadioGroup>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { Product } from '~/types';

const country = inject(countryKeyInjectionKey)!;
const selectedProduct = defineModel<Product>({ required: true });
defineProps<{
  products: Product[];
}>();

const { required } = useValidation();
const { displayPrice } = useFormat();
const { tProductLabel } = useLocalization();
</script>